// import React from "react";
// import {
//   Paper,
//   Typography,
//   List,
//   ListItem,
//   ListItemText,
//   Chip,
//   Box,
//   Divider,
// } from "@mui/material";

// const getStatusColors = (status) => {
//   const key = String(status || "").toLowerCase();

//   if (key === "sent" || key === "delivered") {
//     return { bg: "rgba(34,197,94,0.10)", fg: "#15803d" };
//   }
//   if (key === "bounced" || key === "failed") {
//     return { bg: "rgba(248,113,113,0.10)", fg: "#b91c1c" };
//   }
//   if (key === "queued" || key === "pending") {
//     return { bg: "rgba(234,179,8,0.14)", fg: "#854d0e" };
//   }
//   return { bg: "rgba(148,163,184,0.16)", fg: "#374151" };
// };

// export default function EmailNotificationSummary({ emails = [] }) {
//   const hasEmails = Array.isArray(emails) && emails.length > 0;
//   console.log("emails prop:", emails);

//   const formatTimestamp = (timestamp) => {
//   if (!timestamp) return "No date";

//   const date = new Date(timestamp);
//   return Number.isNaN(date.getTime()) ? "Invalid date" : date.toLocaleString();
// };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           mb: 1.5,
//           display: "flex",
//           alignItems: { xs: "flex-start", sm: "center" },
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="overline"
//             sx={{
//               fontSize: 11,
//               letterSpacing: 0.8,
//               textTransform: "uppercase",
//               color: "text.secondary",
//             }}
//           >
//             Notifications
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{ fontWeight: 700, lineHeight: 1.2 }}
//           >
//             Email / Notification Summary
//           </Typography>
//         </Box>
//         {hasEmails && (
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             sx={{ whiteSpace: "nowrap" }}
//           >
//             {emails.length} event{emails.length > 1 ? "s" : ""}
//           </Typography>
//         )}
//       </Box>

//       <Divider sx={{ mb: 1.5 }} />

//       {/* Content */}
//       {!hasEmails ? (
//         <Box
//           sx={{
//             py: 3,
//             textAlign: "center",
//             color: "text.secondary",
//             fontSize: 14,
//           }}
//         >
//           No recent emails.
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             flex: 1,
//             overflowY: "auto",
//             maxHeight: { xs: 220, sm: 260, md: 300 },
//           }}
//         >
//           <List dense disablePadding>
//             {emails.map((email) => {
//               const colors = getStatusColors(email.status);

//               return (
//                 <ListItem
//                   key={email.id}
//                   sx={{
//                     px: 0,
//                     py: 0.75,
//                     alignItems: "flex-start",
//                     "&:not(:last-of-type)": {
//                       borderBottom: "1px solid",
//                       borderColor: "rgba(229,231,235,0.6)",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary={
//                       <Typography
//                         variant="body2"
//                         sx={{ fontWeight: 500 }}
//                         noWrap
//                       >
//                         {email.type} to {email.to}
//                       </Typography>
//                     }
//                     secondary={
//                       <Typography
//                         variant="caption"
//                         color="text.secondary"
//                       >
//                         {/* {new Date(email.timestamp).toLocaleString()} */}
//                         {formatTimestamp(email.timestamp)}
//                       </Typography>
//                     }
//                   />
//                   <Chip
//                     label={email.status}
//                     size="small"
//                     sx={{
//                       ml: 1,
//                       borderRadius: 999,
//                       height: 22,
//                       fontSize: 11,
//                       fontWeight: 600,
//                       bgcolor: colors.bg,
//                       color: colors.fg,
//                       textTransform: "capitalize",
//                     }}
//                   />
//                 </ListItem>
//               );
//             })}
//           </List>
//         </Box>
//       )}
//     </Paper>
//   );
// }


import React from "react";
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Box,
  Divider,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

const getStatusColors = (status, dark, accent) => {
  const key = String(status || "").toLowerCase();

  if (key === "sent" || key === "delivered") {
    return {
      bg: dark ? "rgba(34,197,94,0.18)" : "rgba(34,197,94,0.10)",
      fg: dark ? "#86efac" : "#15803d",
      border: dark ? "rgba(34,197,94,0.24)" : "rgba(34,197,94,0.18)",
    };
  }

  if (key === "bounced" || key === "failed") {
    return {
      bg: dark ? "rgba(248,113,113,0.18)" : "rgba(248,113,113,0.10)",
      fg: dark ? "#fca5a5" : "#b91c1c",
      border: dark ? "rgba(248,113,113,0.24)" : "rgba(248,113,113,0.18)",
    };
  }

  if (key === "queued" || key === "pending") {
    return {
      bg: dark ? "rgba(245,158,11,0.18)" : "rgba(234,179,8,0.14)",
      fg: dark ? "#fcd34d" : "#854d0e",
      border: dark ? "rgba(245,158,11,0.24)" : "rgba(234,179,8,0.18)",
    };
  }

  return {
    bg: dark ? alpha(accent, 0.14) : alpha(accent, 0.08),
    fg: accent,
    border: alpha(accent, 0.2),
  };
};

export default function EmailNotificationSummary({ emails = [] }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const hasEmails = Array.isArray(emails) && emails.length > 0;

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "No date";
    const date = new Date(timestamp);
    return Number.isNaN(date.getTime()) ? "Invalid date" : date.toLocaleString();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          mb: 1.75,
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: muted,
              fontWeight: 500,
              fontFamily:
                '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
            }}
          >
            Notifications
          </Typography>

          <Typography
            sx={{
              mt: 0.6,
              fontWeight: 800,
              fontSize: "1.35rem",
              lineHeight: 1.15,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Email / Notification Summary
          </Typography>
        </Box>

        {hasEmails && (
          <Typography
            sx={{
              fontSize: "12px",
              color: muted,
              whiteSpace: "nowrap",
            }}
          >
            {emails.length} event{emails.length > 1 ? "s" : ""}
          </Typography>
        )}
      </Box>

      <Divider sx={{ mb: 1.5, borderColor: border }} />

      {!hasEmails ? (
        <Box
          sx={{
            py: 3,
            textAlign: "center",
            color: mid,
            fontSize: 14,
          }}
        >
          No recent emails.
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            maxHeight: { xs: 220, sm: 260, md: 300 },
          }}
        >
          <List dense disablePadding>
            {emails.map((email) => {
              const colors = getStatusColors(email.status, dark, accent);

              return (
                <ListItem
                  key={email.id}
                  sx={{
                    px: 0,
                    py: 0.9,
                    alignItems: "flex-start",
                    "&:not(:last-of-type)": {
                      borderBottom: `1px solid ${border}`,
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: text,
                          lineHeight: 1.6,
                        }}
                        noWrap
                      >
                        {email.type} to {email.to}
                      </Typography>
                    }
                    secondary={
                      <Typography
                        sx={{
                          mt: 0.45,
                          fontSize: "12px",
                          color: mid,
                        }}
                      >
                        {formatTimestamp(email.timestamp)}
                      </Typography>
                    }
                  />

                  <Chip
                    label={email.status}
                    size="small"
                    sx={{
                      ml: 1,
                      borderRadius: 999,
                      height: 24,
                      fontSize: 11,
                      fontWeight: 700,
                      bgcolor: colors.bg,
                      color: colors.fg,
                      border: `1px solid ${colors.border}`,
                      textTransform: "capitalize",
                    }}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}
    </Paper>
  );
}